/* zf-hero: background videos respect reduced motion and only play while visible. */
(function () {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    const videos = root.querySelectorAll('.zf-hero__video, .zf-hero__media video');
    if (!videos.length) return;
    if (reduce.matches) {
      videos.forEach((v) => { v.removeAttribute('autoplay'); v.pause(); });
      return;
    }
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        const v = e.target;
        if (e.isIntersecting) { const p = v.play(); p && p.catch(() => {}); } else { v.pause(); }
      });
    }, { threshold: 0.25 });
    videos.forEach((v) => io.observe(v));
  }
  function boot() { document.querySelectorAll('.zf-hero').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('.zf-hero').forEach(init));
})();
